import { render, staticRenderFns } from "./AddFineItem.vue?vue&type=template&id=4aa89f41"
import script from "./AddFineItem.vue?vue&type=script&lang=js"
export * from "./AddFineItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports